import React from 'react';
import * as S from './styles';
import Texts from '../Texts';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

interface ApproveStatusProps {
  id: string;
  display_name: string;
}
const ApproveStatus: React.FC<ApproveStatusProps> = ({ id, display_name }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/dashboard', {
      state: {
        id,
        display_name,
        // اضافه کردن timestamp برای اطمینان از رفرش
        refreshKey: Date.now(),
      },
      replace: true, // اختیاری - برای جلوگیری از اضافه شدن به history
    });
  };
  return (
    <S.ContentBox>
      <S.SuBox>
        {/* <CheckCircleIcon sx={{ fontSize: '38px', color: '#4caf50' }} /> */}
      </S.SuBox>
      <S.SubTitle as="div">{Texts.Pending.subTitle}</S.SubTitle>

      <S.SuccessBox>
        <Button
          variant="contained"
          //   endIcon={<CheckCircleIcon />}
          sx={{
            width: '95px',
            height: '28px',
            backgroundColor: '#DBFFF0',
            color: '#139961',
            fontFamily: 'IRANYekanXFaNum',
            fontSize: '14px',
            textTransform: 'none',
            boxShadow: 'none',
            padding: '0px',
            '&:hover': {
              backgroundColor: '#DBFFF0',
            },
          }}
        >
          {Texts.Approve.accepted}
        </Button>
        <S.Content>
          <div>{Texts.Pending.user}</div>
          <div
            style={{
              fontSize: '12px',
              color: '#a6aab5',
              marginTop: '8px',
              fontWeight: 'bold',
            }}
          >
            {display_name} - {id}
          </div>
        </S.Content>
      </S.SuccessBox>

      <S.FooterApprove>
        <S.ApproveLabel onClick={() => handleClick()}>
          {Texts.Approve.dashboard}
        </S.ApproveLabel>
      </S.FooterApprove>
    </S.ContentBox>
  );
};

export default ApproveStatus;
